export default {"src":"/_next/static/media/openEye.de0e95c5.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};